<script setup lang="ts">
import { ref, computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

interface DownloadItem {
  titel: string;
  url: string;
  icon?: string;
  type?: 'pdf';
}

const downloads = ref<DownloadItem[]>([
  {
    titel: 'Afstandsverklaring schadevrije jaren',
    url: '../downloads/afstandsverklaring_schadevrije_jaren.pdf',
    type: 'pdf',
  },
  {
    titel: 'Omstandighedenverklaring',
    url: '../downloads/omstandighedenverklaring.pdf',
    type: 'pdf',
  },
  {
    titel: 'UBO formulier',
    url: '../downloads/UBO_formulier_V03.pdf',
    type: 'pdf',
  },
  {
    titel: 'SUREbusiness excellent brandtarief',
    url: '../downloads/SUREbusiness_excellent_brandtarief_(2026).pdf',
    type: 'pdf',
  },
  {
    titel: 'Beveiligingsklassen SCM',
    url: '../downloads/beveiligingsklassen_SCM.pdf',
    type: 'pdf',
  },
  {
    titel: 'Handleiding meerdere accounts SUREnet',
    url: '../downloads/Handleiding_meerdere_accounts_SUREnet.pdf',
    type: 'pdf',
  },
]);

const aantalDownloads = computed(() => downloads.value.length);

function getIconAndColorForType(type?: string): { icon: string; color: string } {
  switch (type) {
    case 'pdf':
      return { icon: 'far fa-file-pdf', color: 'text-red-500' };
    default:
      return { icon: 'far fa-file', color: 'text-grey-500' };
  }
}
</script>

<template>
  <div
    v-if="downloads.length > 0"
    class="overflow-hidden rounded-lg border border-grey-200 bg-white"
  >
    <div class="border-b border-grey-200 bg-grey-50 px-4 py-3">
      <h2 class="font-semibold text-grey-800">Downloads</h2>
      <p class="text-sm text-grey-500">
        {{ aantalDownloads }} document{{ aantalDownloads === 1 ? '' : 'en' }}
      </p>
    </div>

    <ul class="grid grid-cols-1 divide-y divide-grey-100 xl:grid-cols-2">
      <li v-for="(item, index) in downloads" :key="index" class="hover:bg-grey-50">
        <a
          :href="item.url"
          download
          class="flex items-center gap-3 px-4 py-3 text-primary hover:underline"
        >
          <FontAwesomeIcon
            :icon="getIconAndColorForType(item.type).icon"
            :class="getIconAndColorForType(item.type).color"
          />
          {{ item.titel }}
        </a>
      </li>
    </ul>
  </div>

  <p v-else class="mt-6 text-center text-grey-500">Geen downloads beschikbaar.</p>
</template>
